import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const faqs = [
  {
    q: '¿Cuál es el pedido mínimo?',
    a: 'No hay pedido mínimo para particulares. Puedes pedir desde 1 unidad. Para pedidos profesionales (B2B), contacta con nosotros por WhatsApp para conocer condiciones.',
  },
  {
    q: '¿Cómo se hace el pedido?',
    a: 'Selecciona tus croquetas en el catálogo, añádelas al carrito y pulsa "Enviar Pedido por WhatsApp". Se abrirá un mensaje pre-rellenado listo para enviárselo a María José.',
  },
  {
    q: '¿Cuándo puedo recoger mi pedido?',
    a: 'Los pedidos se coordinan directamente por WhatsApp. Normalmente hay disponibilidad los fines de semana. María José te confirmará disponibilidad y hora de recogida.',
  },
  {
    q: '¿Cómo se paga?',
    a: 'El pago se realiza por Bizum o en efectivo en el momento de la recogida. No aceptamos tarjeta por el momento.',
  },
  {
    q: '¿Tienen alérgenos?',
    a: 'Todas nuestras croquetas contienen Gluten y Leche. La variedad Pollo Curry también contiene Frutos Secos (nueces). Cada producto muestra sus alérgenos. Si tienes alergia, indícalo en tu mensaje de WhatsApp.',
  },
  {
    q: '¿Hacen envío a domicilio?',
    a: 'Actualmente solo gestionamos recogida en Las Palmas de Gran Canaria. Estamos valorando opciones de entrega para próximamente.',
  },
  {
    q: '¿Por qué son cuadradas?',
    a: 'El cuadrado es nuestra filosofía: más masa por bocado, bordes perfectos que se doran de manera uniforme y una presencia en el plato que dice que esto es diferente. El Secreto es el Cuadrado.',
  },
];

const FAQItem = ({ question, answer, isOpen, onClick, index }) => (
  <div className="border-b border-[#EBE5DB] last:border-b-0">
    <button
      data-testid={`faq-item-${index}`}
      onClick={onClick}
      className="w-full flex items-center justify-between py-5 text-left group"
    >
      <span className="font-medium text-[#2C2C2A] pr-4 text-sm md:text-base group-hover:text-[#7B1F3A] transition-colors">
        {question}
      </span>
      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center border border-[#EBE5DB] text-[#7B1F3A]">
        {isOpen ? <Minus size={14} /> : <Plus size={14} />}
      </span>
    </button>
    <div
      className={`overflow-hidden transition-all duration-300 ease-in-out ${
        isOpen ? 'max-h-48 pb-5' : 'max-h-0'
      }`}
    >
      <p className="text-[#5A5A58] leading-relaxed text-sm md:text-base">{answer}</p>
    </div>
  </div>
);

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-32 bg-[#EDE7D8]"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#7B1F3A] mb-3">
            Resolvemos tus dudas
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#2C2C2A]">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="bg-white border border-[#EBE5DB] px-6 md:px-10 py-2">
          {faqs.map((faq, i) => (
            <FAQItem
              key={i}
              index={i}
              question={faq.q}
              answer={faq.a}
              isOpen={openIdx === i}
              onClick={() => setOpenIdx(openIdx === i ? null : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
